import { userService } from "../api/user-auth";

const state = {
  personnels: [],
  new_personnel: null,
  personnelsPasswordUpdated: 0,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  personnels: (state, getters) => {
    return state.personnels;
  },
};

const actions = {
  loadPersonnels({ commit }, personnels) {
    commit("loadPersonnels", personnels);
  },
  getPersonnels({ dispatch, commit }) {
    userService.getJson("personnel/list").then(
      response => {
        if (response.ok) {
          commit("loadPersonnels", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSavePersonnel({ dispatch, commit }, personnel) {
    userService.post("personnel/" + personnel.id, personnel).then(
      response => {
        if (response.ok) {
          commit("updatePersonnel", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreatePersonnel({ dispatch, commit }, personnel) {  // personnel = data 
    userService.post("personnel/" + personnel.id, personnel).then(
      response => {
        if (response.ok) {
          commit("addPersonnel", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },

  apiCreatePassword({ dispatch, commit }, password_data) {
    userService.post("personnel/password", password_data).then(
      response => {
        if (response.ok) {
          // do nothing
          commit("UpdatedPersonnelPassword");
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },

};

const mutations = {
  addPersonnel(state, personnel) {
    state.personnels.push(personnel);
    state.new_personnel = personnel;
  },
  updatePersonnel(state, personnel) {
    var index = state.personnels.findIndex(v => v.id == personnel.id);
    state.personnels[index] = personnel;
  },
  loadPersonnels(state, personnels) {
    state.personnels = personnels;
  },
  UpdatedPersonnelPassword(state) {
    state.personnelsPasswordUpdated += 1;
  },
  clear(state) {
    state.personnels = [];
  },
};

export const personnels = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
